import React from "react";
import { Alert, Box, CircularProgress, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import SeoHead from "../components/SeoHead";
import FeaturedChallengeCard from "../components/community/FeaturedChallengeCard";
import RosterCard from "../components/community/RosterCard";
import { useGetCommunityChallengeQuery } from "../store/api/communityApi";
import { useSportWorkspace } from "../hooks/useSportWorkspace";

const CommunityChallenge = ({ publicView = false }) => {
  const { idOrSlug } = useParams();
  const { sport } = useSportWorkspace();
  const { data: challenge, isLoading, error } = useGetCommunityChallengeQuery(
    idOrSlug,
    { skip: !idOrSlug }
  );

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error || !challenge) {
    return <Alert severity="info">Challenge not found.</Alert>;
  }

  return (
    <Box sx={{ py: publicView ? 0 : { xs: 1, sm: 2 }, maxWidth: 880, mx: "auto" }}>
      <SeoHead
        title={`${challenge.title} — Stats.Fan Community`}
        description={challenge.description || "A Stats.Fan roster challenge."}
      />
      <Typography variant="overline" color="text.secondary" sx={{ letterSpacing: "0.16em" }}>
        Challenge
      </Typography>
      <Box sx={{ mt: 2 }}>
        <FeaturedChallengeCard challenge={challenge} sport={challenge.sport || sport} />
      </Box>
      <Typography variant="h6" fontWeight={700} sx={{ mt: 4, mb: 1.5 }}>
        Entries
      </Typography>
      {(challenge.entries || []).length === 0 ? (
        <Typography color="text.secondary">No published entries yet.</Typography>
      ) : (
        <Box sx={{ display: "grid", gap: 2 }}>
          {challenge.entries.map((roster) => (
            <RosterCard
              key={roster.id}
              roster={roster}
              sport={challenge.sport || sport}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CommunityChallenge;
